import { GetDataSchemaParams, GetExternalWmsLayersParams, GetExternalArcGisLayersParams } from "@evergis/api";
import { createMutation } from "@evergis/react-fetching";

import { api as evergisApi } from "../evergis/api";

export const importFile = createMutation(
  ({ fileId }: GetDataSchemaParams) =>
    async api => {
      return {
        data: await api.import.getDataSchema({ fileId }),
      };
    },
  {
    injected: evergisApi,
  },
);

export const importWmsLayers = createMutation(
  (params: GetExternalWmsLayersParams) => async api => {
    return {
      data: await api.import.getExternalWmsLayers(params),
    };
  },
  {
    injected: evergisApi,
  },
);

export const importArcGISLayers = createMutation(
  (params: GetExternalArcGisLayersParams) => async api => {
    return {
      data: await api.import.getExternalArcGisLayers(params),
    };
  },
  {
    injected: evergisApi,
  },
);
